import { styled } from "@mui/joy";
import { PanelResizeHandle } from "react-resizable-panels";

export const StyledPanelResizeHandle = styled(PanelResizeHandle)({
    background: "var(--joy-palette-neutral-100, #DDE7EE)",
    width: "8px",
    cursor: "col-resize",
    position: "relative",

    "&:hover": {
        "&::before": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "4px",
            height: "32px",
            borderRadius: "4px",
            backgroundColor: "var(--joy-palette-neutral-500, #DDE7EE)",
        },
    },
});
